import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPermissionsModule } from 'ngx-permissions';
import { TradingPartnersComponent } from './trading-partners.component';
import { routes } from './trading-partners.routing';
import { TradingPartnerService } from 'app/services/trading-partner.service';
import { TableModule } from 'primeng/table';
import { PipesModule } from '../pipes/pipes.module';
import { TableExtensionService } from '../oes/table-extension.service';
import { MaterialModule } from '../material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridFiltersService } from 'app/services/grid.filters.service';
import { TooltipModule, ConfirmDialogModule } from 'primeng/primeng';
import { TpNewCustomerComponent } from './tp-new-customer/tp-new-customer.component';
import { TradingPartnerModalComponent } from './trading-partner-modal/trading-partner-modal.component';
import { TradingPartnerSaveModalComponent } from './trading-partner-save-modal/trading-partner-save-modal.component';
import { TpNewVendorComponent } from './tp-new-vendor/tp-new-vendor.component';
import { LoadingModule } from 'ngx-loading';
import {MatDialogModule} from '@angular/material';

@NgModule({
    imports: [
        CommonModule,
        NgbModule,
        NgxPermissionsModule.forChild(),
        RouterModule.forChild(routes),
        TableModule,
        PipesModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        TooltipModule,
        ConfirmDialogModule,
        LoadingModule,
        MatDialogModule,
    ],
  declarations: [
    TradingPartnersComponent,
    TpNewCustomerComponent,
    TradingPartnerModalComponent,
    TradingPartnerSaveModalComponent,
    TpNewVendorComponent,
  ],
  providers: [TradingPartnerService, TableExtensionService, GridFiltersService],
  entryComponents: [TradingPartnerModalComponent, TpNewVendorComponent],
})
export class TradingPartnersModule {}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/trading-partners/trading-partners.module.ts